import { render, staticRenderFns } from "./ScrollUp.vue?vue&type=template&id=8e890160&"
import script from "./ScrollUp.vue?vue&type=script&lang=js&"
export * from "./ScrollUp.vue?vue&type=script&lang=js&"
import style0 from "./ScrollUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports